import React from "react";

import { useDebouncedState } from "@common/hooks";
import { TextField, TextFieldProps } from "@mui/material";

const DebouncedTextField = ({
  value: propsValue,
  onChange,
  immediateCallback,
  ...other
}: Omit<TextFieldProps, "onChange" | "value"> & {
  value: string | undefined;
  onChange: (value: string) => void;
  immediateCallback?: () => void;
}) => {
  const [value, setValue] = useDebouncedState(propsValue ?? "", onChange);

  return (
    <TextField
      value={value}
      {...other}
      onChange={(e) => {
        if (typeof immediateCallback === "function") {
          immediateCallback();
        }
        setValue(e.target.value);
      }}
    />
  );
};

export default DebouncedTextField;
